import React, { useEffect, useState } from "react";
import { Modal, Nav, Tab, Container, Row, Col } from "react-bootstrap";
import { DefaultModalProps, IModalProps } from "../Modal.types";
import ModalStyles from "../Modal.styles";
import { useSelector } from "react-redux";
import { RootState } from "../../../state-management/root-reducer";
import OutageReconciliationStyles from "./OutageReconciliation.styles";
import ACCEPT_PANE from "./AcceptPane.component";
import REJECT_PANE from "./RejectPane.component";
import { ApiService } from "../../../api/api.service";

const OUTAGE_RECONCILIATION_MODAL: React.FC<IModalProps> = (
  props: IModalProps
) => {
  // App State
  const { adminMode } = useSelector((state: RootState) => state.globalState.ui);

  // Local State
  const [show, setShow] = useState(false);

  // Services
  const apiService: ApiService = ApiService.getInstance();

  const { handleClose, centered, size } = props;
  const { selectedOutage } = adminMode;
  const contact =
    selectedOutage && selectedOutage.contacts
      ? selectedOutage?.contacts[0]
      : {
          name: "",
          email: "",
          mobilePhone: "",
        };

  const { name, email, mobilePhone } = contact;

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <ModalStyles.OutageReconciliationModal
      dialogClassName="outage-reconciliation-modal"
      show={show}
      size={size}
      centered={centered}
      onHide={handleClose}
    >
      <Modal.Header className="modal-header" closeButton>
        <Container fluid>
          <Row>
            <Col className="label-column">Outage Id:</Col>
            <Col className="value-column">
              <a
                href={`${apiService.getBaseUrl()}/?outageId=${
                  selectedOutage?.outageId
                }`}
                target="_blank"
                rel="noreferrer"
              >
                {selectedOutage?.outageId}
              </a>
            </Col>
          </Row>
          <Row>
            <Col className="label-column">Address:</Col>
            <Col className="value-column">
              {`${selectedOutage?.location?.address}, ${selectedOutage?.location?.city}, MI`}
            </Col>
          </Row>
        </Container>
      </Modal.Header>
      <Modal.Body>
        <Container className="contact-info-container" fluid>
          <Row>
            <Col className="label-column">Name:</Col>
            <Col className="value-column">{name}</Col>
          </Row>
          <Row>
            <Col className="label-column">Email:</Col>
            <Col className="value-column">
              <a
                href={`mailto:${email}?subject=RE: SOAR Outage #${selectedOutage?.outageId}`}
              >
                {email}
              </a>
            </Col>
          </Row>
          <Row>
            <Col className="label-column">Phone:</Col>
            <Col className="value-column">
              <a href={`tel:${mobilePhone}`}>{mobilePhone}</a>
            </Col>
          </Row>
          <Row>
            <Col className="label-column">Comments:</Col>
            <Col className="value-column">{selectedOutage?.comments}</Col>
          </Row>
        </Container>
        <Tab.Container defaultActiveKey="accept">
          <Nav className="tab-nav" variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="accept">Accept Outage</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="reject">Reject Outage</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <OutageReconciliationStyles.AdminModalPane
              className="admin-modal-pane"
              eventKey="accept"
            >
              <ACCEPT_PANE
                selectedOutage={selectedOutage}
                handleClose={handleClose}
              />
            </OutageReconciliationStyles.AdminModalPane>
            <OutageReconciliationStyles.AdminModalPane
              className="admin-modal-pane"
              eventKey="reject"
            >
              <REJECT_PANE
                selectedOutage={selectedOutage}
                handleClose={handleClose}
              />
            </OutageReconciliationStyles.AdminModalPane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
    </ModalStyles.OutageReconciliationModal>
  );
};

OUTAGE_RECONCILIATION_MODAL.defaultProps = DefaultModalProps;
export default OUTAGE_RECONCILIATION_MODAL;
